import { createStore as createJotaiStore } from "jotai";

export const jotaiStore = createJotaiStore();
